import { memo } from 'react';

import { type Form, type ShortUrlResponse } from '@air/api/types';
import { Button } from '@air/primitive-button';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { useRegenerateShortIdForForm } from '~/swr-hooks/shortUrl/useRegenerateShortIdForForm';
import { type EditShareLinkView } from '~/types/ShareLink';

type ContentCollectionGenerateActionsProps = {
  form: Form;
  shortIdInfo: ShortUrlResponse;
  setView: (view: EditShareLinkView) => void;
};

export const ContentCollectionGenerateActions = memo(
  ({ form, shortIdInfo, setView }: ContentCollectionGenerateActionsProps) => {
    const { currentWorkspace } = useCurrentWorkspace();
    const { regenerateShortIdForForm } = useRegenerateShortIdForForm();

    return (
      <div className="flex justify-end gap-2">
        <Button
          appearance="ghost"
          color="grey"
          size="large"
          data-testid="REGENERATE_CONTENT_COLLECTION_CANCEL"
          onClick={() => setView('edit')}
        >
          Cancel
        </Button>
        <Button
          appearance="filled"
          color="blue"
          size="large"
          data-testid="REGENERATE_CONTENT_COLLECTION_ACCEPT"
          onClick={() => {
            const workspaceId = currentWorkspace?.id;
            if (!workspaceId) {
              throw new Error('No workspace id');
            }
            regenerateShortIdForForm.mutate(
              {
                workspaceId,
                shortId: shortIdInfo.id,
                boardContext: form.boardId,
                formId: form.id,
              },
              {
                onSuccess: () => {
                  setView('edit');
                },
              },
            );
          }}
          isLoading={regenerateShortIdForForm.isPending}
          disabled={regenerateShortIdForForm.isPending}
        >
          Generate new link
        </Button>
      </div>
    );
  },
);

ContentCollectionGenerateActions.displayName = 'ContentCollectionGenerateActions';
